import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 624.000000 627.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,627.000000) scale(0.100000,-0.100000)" >


<path d="M0 6245 l0 -25 3120 0 3120 0 0 25 0 25 -3120 0 -3120 0 0 -25z"/>
<path d="M3958 5433 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2110 5369 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4115 5370 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4260 5356 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M4660 5100 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4765 5010 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4935 4780 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5005 4710 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5065 4640 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3961 3938 c-73 -145 -190 -373 -258 -508 -69 -135 -129 -249 -134
-254 -4 -5 -19 15 -32 45 -27 60 -72 157 -153 327 -30 63 -54 118 -54 123 0
45 -57 -57 -156 -280 l-32 -74 206 -412 c114 -228 211 -412 217 -411 10 3 8
-1 200 371 224 437 263 510 272 509 12 -2 18 -18 128 -359 165 -511 151 -477
204 -506 204 -111 333 -179 341 -179 5 0 -6 44 -24 98 -19 53 -85 252 -147
442 -61 190 -183 561 -270 824 -88 263 -159 485 -159 492 0 8 -3 14 -8 14 -4
0 -67 -118 -141 -262z"/>
<path d="M2371 4032 c-47 -86 -94 -173 -106 -192 -12 -19 -89 -159 -172 -310
-153 -280 -174 -318 -248 -450 -23 -41 -59 -106 -80 -145 -76 -142 -98 -181
-115 -210 -10 -16 -30 -52 -45 -80 -15 -27 -50 -89 -76 -138 -27 -48 -49 -89
-49 -92 0 -3 -11 -23 -25 -46 -14 -22 -23 -44 -20 -49 3 -5 77 -8 168 -7 l162
2 15 30 c8 17 39 71 68 121 28 50 52 94 52 97 0 5 -49 -21 -263 -137 -49 -27
-90 -46 -93 -43 -5 4 175 129 369 256 64 42 71 51 131 160 99 179 126 227 272
499 75 138 139 252 143 252 5 0 25 -35 46 -77 l37 -78 74 154 c41 85 77 164
80 176 4 15 -25 80 -93 211 -53 104 -104 203 -113 221 -8 18 -19 32 -25 33 -5
0 -48 -71 -94 -158z"/>
<path d="M3027 4078 c-31 -62 -150 -306 -266 -541 -116 -236 -211 -432 -211
-436 0 -4 -8 -15 -18 -24 -14 -13 -44 -17 -132 -19 l-115 -3 -82 -150 c-45
-82 -82 -153 -82 -157 -1 -5 138 -8 307 -8 l308 0 267 532 267 532 -19 41
c-22 45 -120 262 -142 313 -8 17 -17 32 -21 32 -3 0 -31 -51 -61 -112z"/>
<path d="M5561 3754 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5546 3615 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"/>
<path d="M5642 3330 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M3083 3078 c-5 -7 -44 -83 -87 -168 l-78 -156 104 -203 c58 -112 113
-212 122 -222 14 -17 31 -19 174 -19 87 0 162 3 165 6 3 4 -24 66 -62 138 -37
72 -126 244 -196 381 -71 138 -129 251 -130 253 -1 1 -6 -3 -12 -10z"/>
<path d="M5652 3050 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M592 2885 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5642 2885 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5521 2304 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M1701 2074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M3380 2065 c1 -6 7 -21 16 -35 l15 -25 -7 25 c-7 26 -24 52 -24 35z"/>
<path d="M3478 2053 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2746 2033 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M2870 1990 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M2588 1983 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3469 1973 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M1951 1963 c-1 -28 8 -53 21 -53 7 0 7 4 0 13 -5 6 -12 23 -15 37 -4
22 -4 22 -6 3z"/>
<path d="M1755 1950 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2740 1953 c0 -11 38 -49 43 -42 2 2 -7 15 -20 28 -13 13 -23 20 -23
14z"/>
<path d="M2430 1930 c0 -11 4 -20 9 -20 5 0 7 9 4 20 -3 11 -7 20 -9 20 -2 0
-4 -9 -4 -20z"/>
<path d="M3460 1930 c6 -11 16 -20 22 -20 6 0 3 9 -7 20 -10 11 -20 20 -22 20
-2 0 1 -9 7 -20z"/>
<path d="M4025 1930 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M1860 1920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2170 1920 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2555 1920 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M2640 1919 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M2850 1920 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M2965 1920 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4330 1920 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M1710 1046 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M1788 993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3688 623 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3608 613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2888 573 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
